import "./partials/footer/style.scss";
import "./partials/header";
import renderTemplate from "./utils/renderTemplate.js";

// Render page partials
const partials = document.querySelectorAll("[data-partial]");
partials.forEach((template) => {
    const name = template.dataset.partial;
    if (name) {
        renderTemplate(template, `partials/${name}`);
    }
});
